import React, { useState, useRef } from 'react';
import attchefileicon from '../../../assets/images/attchefileicon.svg';
import '../IssuesPage/IssuesPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceSmileWink } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import AttachmentPreview from './AttachmentPreview';
import RichTextEditor from '../../ui/RichTextEditor/RichTextEditor';
import { User } from '../../../interfaces/User';

interface CommentInputProps {
    value: string;
    onChange: (value: string) => void;
    onFilesChange: (files: File[]) => void;
    onSubmit: () => void;
    attachments: File[];
    isSubmitting: boolean;
    users: User[];
}

const CommentInput: React.FC<CommentInputProps> = ({ value, onChange, onFilesChange, onSubmit, attachments, isSubmitting, users }) => {
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);

    const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
        const items = e.clipboardData.items;
        const newFiles: File[] = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                const file = items[i].getAsFile();
                if (file) {
                    newFiles.push(file);
                }
            }
        }
        if (newFiles.length > 0) {
            onFilesChange([...attachments, ...newFiles]);
        }
    };

    return (
        <div className="comment-input-section">
            {attachments.map((file, index) => (
                <AttachmentPreview key={index} file={file} onRemove={() => onFilesChange(attachments.filter((_, i) => i !== index))} />
            ))}
            <div onPaste={handlePaste}>
                <RichTextEditor
                    value={value}
                    onChange={onChange}
                    users={users}
                    placeholder="Add a comment..."
                />
            </div>
            <div className="comment-actions">
                <div className="comment-actions-left">
                    <label htmlFor="file-input" className="attachment-label">
                        <img src={attchefileicon} alt="Attach file" />
                    </label>
                    <input
                        id="file-input"
                        type="file"
                        multiple
                        onChange={e => e.target.files && onFilesChange([...attachments, ...Array.from(e.target.files)])}
                        style={{ display: 'none' }}
                    />
                    {/* Emoji picker functionality can be enhanced or kept as is */}
                </div>
                <Button variant="primary"
                    className="btn_sm" onClick={onSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Comment'}
                </Button>
            </div>
        </div>
    );
};

export default CommentInput;
